import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SearchService } from '@nucleus/ui-base';
import { ServiceHandler } from '@nucleus/ui-base';
import { PageResult } from '@nucleus/ui-base';
import { Page, QuerySortDirection } from '@nucleus/ui-base';
import { SchedulerFilter } from './scheduler-filter';
import { SampleEventCalculationRequestPayload } from './sample-event-calculation-request-payload';
import { Event, SchedulerControllerService, SchedulerDefinition, JobControllerService, JobUpsertRequest, Job } from '../../api/scheduler-service';
import { RequestHandler } from '../request-handler';


@Injectable({
  providedIn: 'root'
})
export class SchedulerService implements SearchService<SchedulerDefinition, SchedulerFilter> {

  constructor(
    private api: SchedulerControllerService,
    private jobApi: JobControllerService,
    private requestHandler: RequestHandler,
  ) { }

  /** Persist a scheduled Job (TASK-221 S1 SAVE). Blocking — the operator waits
   *  for the create to confirm before navigating away. */
  createJob(req: JobUpsertRequest, handler: ServiceHandler<Job>): void {
    this.requestHandler.handleRequest(this.jobApi.create(req) as unknown as Observable<Job>, handler, true);
  }


  search(handler: ServiceHandler<SchedulerDefinition[]>): void {
  }

  searchPaginated(handler: ServiceHandler<PageResult<SchedulerDefinition>>, pageSize: number, pageNumber: number, softField: string, sortDirection: QuerySortDirection) {
  }

  filterPaginated(handler: ServiceHandler<PageResult<SchedulerDefinition>>, pageSize: number, pageNumber: number, softField: string, sortDirection: QuerySortDirection, filter: SchedulerFilter): void {
  }


  filter(handler: ServiceHandler<PageResult<SchedulerDefinition>>, filter: SchedulerFilter, page?: Page, _clientId?: string): void {
  }

  calculate(def: SchedulerDefinition, sampleSize: number, handler: ServiceHandler<Event[]>): void {
    const payload = new SampleEventCalculationRequestPayload(def, sampleSize);
    this.requestHandler.handleRequest(this.api.next(payload as any) as unknown as Observable<Event[]>, handler, false);
  }


  describe(def: SchedulerDefinition, handler: ServiceHandler<String>): void {
    this.requestHandler.handleRequest(this.api.describe(def as any) as unknown as Observable<String>, handler, false);
  }

  // Converts "HH:mm" time string to minutes
  timeToMinutes(time: string): number {
    const [_, hoursStr, minutesStr, meridian] = time.match(/^(\d{1,2}):(\d{2})\s?(AM|PM)$/i) || [];

    if (!hoursStr || !minutesStr || !meridian) {
      throw new Error(`Invalid time format: "${time}"`);
    }

    let hours = parseInt(hoursStr, 10);
    const minutes = parseInt(minutesStr, 10);

    if (meridian.toUpperCase() === 'PM' && hours !== 12) {
      hours += 12;
    }
    if (meridian.toUpperCase() === 'AM' && hours === 12) {
      hours = 0;
    }

    return hours * 60 + minutes;
  }

  // Converts minutes to "HH:mm" format
  minutesToTime(totalMinutes: number): string {
    const hours24 = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    const meridian = hours24 >= 12 ? 'PM' : 'AM';
    const hours12 = hours24 % 12 === 0 ? 12 : hours24 % 12;

    const paddedMinutes = minutes.toString().padStart(2, '0');

    return `${hours12}:${paddedMinutes} ${meridian}`;
  }

  // Converts minutes to "HH:mm" format
  minutesToTime24(totalMinutes: number): string {
    const hours = Math.floor(totalMinutes / 60);
    const mins = totalMinutes % 60;
    return `${hours.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}`;
  }
}
